import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { ShieldAlert, UserCheck, Clock } from 'lucide-react';

export const FaceRegistrationBlock = ({ daysRemaining }) => {
  const navigate = useNavigate();
  const isBlocked = daysRemaining <= 0;

  if (!isBlocked && daysRemaining === undefined) return null;

  if (isBlocked) {
    return (
      <div className="p-4 md:p-6 max-w-lg mx-auto" data-testid="face-block-screen">
        <Card className="border-red-300 bg-red-50">
          <CardContent className="p-6 text-center space-y-4">
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 flex items-center justify-center">
              <ShieldAlert className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-red-800">Pendaftaran Wajah Diperlukan</h2>
            <p className="text-red-700 text-sm">
              Grace period 2 hari telah berakhir. Anda <strong>tidak dapat melakukan absensi</strong> hingga wajah Anda terdaftar di sistem.
            </p>
            <Alert className="border-red-200 bg-white text-left">
              <UserCheck className="w-4 h-4 text-red-600" />
              <AlertDescription className="text-red-800 text-sm">
                Buka halaman <strong>Profil</strong>, lalu klik <strong>"Daftarkan Wajah Saya"</strong> untuk memulai proses pendaftaran wajah.
              </AlertDescription>
            </Alert>
            <Button
              className="w-full bg-red-600 hover:bg-red-700 text-white h-12 font-semibold"
              onClick={() => navigate('/profil')}
              data-testid="go-to-profil-btn"
            >
              <UserCheck className="w-5 h-5 mr-2" />
              Daftarkan Wajah Sekarang
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Grace period warning (still allowed)
  return (
    <Alert className="mb-4 border-amber-300 bg-amber-50" data-testid="grace-period-warning">
      <Clock className="w-4 h-4 text-amber-600" />
      <AlertDescription className="text-amber-800">
        <strong>Wajah belum terdaftar.</strong> Sisa grace period: <strong>{daysRemaining} hari</strong>.
        Segera daftarkan wajah di halaman{' '}
        <button onClick={() => navigate('/profil')} className="underline font-semibold text-amber-900 hover:text-amber-700">
          Profil
        </button>.
      </AlertDescription>
    </Alert>
  );
};
